// src/data.js
export default [
  {
    imageUrl: require('./assets/logoo-min.jpg'),
    caption: 'معرفی شرکت',
    secondaryCaption: '',
    secondaryImages: [
      {
        imageUrl: null,
        description: 'شرکت مهندسین مشاور پردیس آمایش سرزمین با شماره ثبتی ۳۳۰۷۸ با دریافت رتبه بندی از سازمان مدیریت و برنامه ریزی در زمینه مسکونی تجاری اداری صنعتی و نظامی و با موضوع مشاوره و طراحی پروژه های عمرانی معماری و شهرسازی طراحی داخلی، مطالعات در مراحل شناسایی و توجیه فنی و اقتصادی طرحها، تهیه نقشه اسناد و مدارک و مشخصات اجرایی طرحها نظارت بر حسن اجرا و انجام خدمات مشاوره ای مربوط به دوره های بهره برداری و نگهداری و پژوهش و مطالعه در حوزه هنر معماری و ساختمان و تهیه طرحهای اجرایی معماری و شهرسازی اعم از ساختمان طرحهای جامع منطقه ای شهرستان شهر و حریم آنها طرح های هادی شهری و روستایی، تهیه طرح های تفصیلی و آماده سازی اراضی و تفکیک اراضی در سال ۱۳۹۰ در اداره کل ثبت شرکتها و موسسات غیر تجاری ایران و در واحد ثبتی شهر تبریز به ثبت رسیده است.<br><br>این شرکت با ترکیبی از مدیران و متخصصین جوان در کنار مهندسین با سابقه در کلیه تخصص های مربوط به معماری شهرسازی و طراحی شهری که شامل اساتید دانشگاه نیز می باشد. مجموعه ای موفق و کارآمد را تشکیل داده است'
      },
    ]
  },
  {
    imageUrl: require('./assets/Thumbs-min.png'),
    caption: 'نقاط قوت',
    secondaryCaption: 'Strengths',
    secondaryImages: [
      {
        imageUrl: require('./assets/Thumbs-min.png'),
        description: 'مشارکت این مهندسین مشاور با مهندسین مشاور زیستا در خصوص تهیه طرحهای تفصیلی شهر تبریز<br><br>کارشناس مسئول تهیه طرحهای تفصیلی مناطق ۳.۴۰۷۰۹ شهر تبریز<br><br>بازنگری طرح شهرک خاوران به وسعت ۸۷۰ هکتار و اخذ سند مالکیتی به وسعت ۳۵۰ هکتاری برای اولین بار در تاریخ جمهوری اسلامی ایران از لحاظ وسعت',
      },
      {
        imageUrl: null,
        description: 'طراحی و برنامه ریزی فاز ۲ خاوران به وسعت ۷۰۰ هکتار<br><br>نظارت کارگاهی بخشی از شهرک خاوران به عنوان شهرک مدرن خاورمیانه<br><br>مشاور مادر مشاور عامل چهارم ( شهرداری تبریز در خصوص کلیه پروژه های اجرایی شهرک خاوران هم در حوزه مشاوران هم پیمانکاران<br><br>نظارت کارگاهی پروژه ۴۳۰ هکتاری شهرک صیاد شیرازی و حل توسعه شبکه آبی و برقی شهرک و اخذ اسناد مالکیتی ۶ دانگی شهرک<br><br>ابتکارات و خلاقیت در تهیه طرحهای تفصیلی شهرهای بوکان تبریز با ارائه نوآوری و تدوین مبانی<br><br>مطالعات سیما و منظر شهری خاوران و تدوین الگوهای عملکردی آن در بین کشورهای منطقه طراحی و بدنه سازی مهرانه رود به عنوان محور گردشگری تبریز برای شهرداری تبریز در دست تصویب'
      },
      {
        imageUrl: null,
        description: 'طراحی و اجرای حدودا ۷ پروژه بزرگ شهری در مقیاس کلان<br><br>بازنگری طرح تفصیلی و حل مشکل شهرک شهید صیاد شیرازی<br><br>انواع گواهینامه ها و ایزوها و شرکت در سمینارهای مختلف<br><br>مشارکت در تهیه طرح جامع شهر ملکان برای مشاور ایرانشهر توس به عنوان دفتر محلی<br><br>تهیه بیش از ده ها طرح هادی شهر برای استان آذربایجان شرقی و غربی<br><br>برنامه ریزی کالبدی طرحهای تحصیلی برای اولین بار در کشور'
      },

    ]
  },
  {
    imageUrl: require('./assets/good-min.jpg'),
    caption: 'نقاط قوت شرکت',
    secondaryCaption: 'Strengths',
    secondaryImages: [
      {
        imageUrl: require('./assets/good-min.jpg'),
        description: 'چندین طرح مطالعاتی و راهبردی شهری و سند توسعه و راهبردی برای شهر بانه و سنندج<br><br>ارائه طرح تفصیلی شهر اهر به عنوان طرح پایلوت در محیط برای اولین بار در سال ۱۳۸۱<br><br>بیش از ۵۰ طرح ساماندهی ، مکانیابی طرح های توجیحی اقتصادی مطالعات ترافیکی شهرک های صنعتی ، مطالعات موزه میراث فرهنگی و گردشگری'
      },
      {
        imageUrl: null,
        description: 'حضور در بیش از ۵۰ کنفرانس و همایش داخلی و خارجی به عنوان ارائه دهنده مقالات فعالیت در خبرنامه ارک سازمان نظام مهندسی ساختمان استان و خبرنامه ساختمان عضویت در سازمان نظام مهندسی ساختمان استان<br><br>آماده سازی اراضی حدود ۲۵۰ هکتار از طرح جامع شهر مراغه به عنوان طرح منتخب شهرداری مراغه طراحی هتل ۵ ستاره و مجتمع تجاری ۸۱۰۰۰ متر مربع خاوران و مجتمع ورزشی در شهر تبریز بیش از ۵۰ مقاله در حوزه شهرسازی در ژورتانهای داخلی و حدود ۱۰ مقاله ISI<br><br>عضو هیئت علمی دانشگاه در دانشگاههای مختلف توسط همکاران مشاور<br><br>اخذ گواهی رضایت مندی از سوی کارفرمایان قبلی تاکنون به پاس خدمات ارزنده ارائه شده<br><br>صدور بیش ۱۰۰۰۰۰ شناسنامه ملک جهت دریافت سند مالکیت<br><br>همکاری با بیش از ۴۰ تعاونی مسکن در استان آذربایجان شرقی'
      },
      {
        imageUrl: null,
        description: 'مطالعات طرح سرمایه گذاری تفرجگاه ائل باغی تبریز به وسعت ۲۳۰ هکتار<br><br>دارای افراد متخصص و متعهد به معنای واقعی کلمه و خدمت به کارفرمایان<br><br>نماینده تام الاختیار گروهی از ایرانیان خارج از کشور در مورد اراضی تحت مالکیت ایشان <br><br>صدور بیش ۱۰۰۰۰۰ شناسنامه ملک جهت دریافت سند مالکیت<br><br>همکاری با بیش از ۴۰ تعاونی مسکن در استان آذربایجان شرقی<br><br>نماینده تام الاختیار دادگستری اهر در خصوص املاک این اداره'
      },
    ]
  },
  {
    imageUrl: require('./assets/Arch-min.jpg'),
    caption: 'عمده فعالیتهای بخش معماری',
    secondaryCaption: 'Main activities of the architecture department',
    secondaryImages: [
      {
        imageUrl: require('./assets/Arch-min.jpg'),
        Fdescription: 'طراحی معماری<br><br>طراحی داخلی<br><br>طراحی محوطه و فضای سبز<br><br>طراحی در زمینه مرمت و نوسازی ابنیه<br><br>طراحی سازه<br><br>طراحی تاسیسات برقی و مکانیکی',
        Fdescription2: 'Architectural Design<br><br>interior design<br><br>Landscaping and green space design<br><br>Design in the field of building renovation and renovation<br><br>Structure design<br><br>Electrical and mechanical installation design'
      },
    ]
  },
  {
    imageUrl: require('./assets/urb2-min.jpg'),
    caption: 'عمده فعالیتهای بخش شهرسازی',
    secondaryCaption: 'Main activities of the urban development department',
    secondaryImages: [
      {
        imageUrl: require('./assets/urb2-min.jpg'),
        Fdescription: 'مطالعات تحقیق و پژوهش در مسائل شهری و منطقه ای<br><br>تهیه طرح های توسعه و عمران<br><br>تهیه طرح تفصیلی<br><br>تهیه تفکیک',
        Fdescription2: 'Research studies in urban and regional issues<br><br>Preparation of development and construction plans<br><br>Preparing a detailed plan<br><br>Preparation of separation'
      },
      {
        imageUrl: null,
        Fdescription: 'مطالعات طرح تطبیق کاربری اراضی و تغییر کاربری اراضی<br><br>تهیه طرح هادی<br><br>سامان دهی بافتهای فرسوده شهری و حاشیه نشینی<br><br>تهیه طرح های زیبا سازی شهری و پارک',
        Fdescription2: 'Land use adaptation plan studies and land use change<br><br>Conductor plan preparation<br><br>Organizing worn-out urban and suburban structures<br><br>Preparation of urban and park beautification plans'
      },
    ]
  },
  {
    imageUrl: require('./assets/research-min.jpg'),
    caption: 'عمده فعالیتهای بخش تحقیقات',
    secondaryCaption: 'Main activities of the research department',
    secondaryImages: [
      {
        imageUrl: require('./assets/research-min.jpg'),
        Fdescription: 'امکان سنجی فنی و اقتصادی و اجتماعی و زیست محیطی<br><br>کنترل پروژه ها و مهندسی ارزشی<br><br>برنامه ریزی پروژههای مختلف با کاربری های مختلف',
        Fdescription2: 'Technical, economic, social and environmental feasibility<br><br>Project control and value engineering<br><br>Planning different projects with different uses'
      },
    ]
  },
  
  
    
    // Add more data as needed
  ];